import {
  EntitySelect,
  EntitySelectEntity,
} from '@factorialco/factorial-one-react/dist/experimental'
import { MeetingEmployeeSelectorDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface EmployeeSelectorProps {
  employee: EntitySelectEntity | null
  setEmployee: (employee: EntitySelectEntity | null) => void
}

const EmployeeSelector = ({ employee, setEmployee }: EmployeeSelectorProps) => {
  const { data, loading: employeesLoading } = useQuery(MeetingEmployeeSelectorDocument)

  return (
    <EntitySelect
      loading={employeesLoading}
      entities={
        data?.employees?.employees?.map(({ id, avatar, fullName }) => ({
          avatar: buildUrl(avatar?.url),
          expanded: false,
          id,
          name: fullName,
        })) || []
      }
      notFoundSubtitle={i18n.t('meetings.create_instant_meeting.not_found_subtitle')}
      notFoundTitle={i18n.t('meetings.create_instant_meeting.not_found_title')}
      onGroupChange={() => {}}
      onItemExpandedChange={() => {}}
      onSelect={(value) => {
        setEmployee(value)
      }}
      searchPlaceholder={i18n.t('meetings.create_instant_meeting.employee_search_placeholder')}
      selectedEntities={employee ? [employee] : []}
      selectedLabel={i18n.t('meetings.create_instant_meeting.selected')}
      singleSelector
      triggerPlaceholder={i18n.t('meetings.create_instant_meeting.employee_placeholder')}
      triggerSelected={i18n.t('meetings.create_instant_meeting.employees_selected')}
      groups={[]}
      selectedGroup="all"
    />
  )
}

export default EmployeeSelector
